import React from 'react';
import { useTranslation } from 'react-i18next';
import PaymentMethod from '../PaymentMethods/PaymentMethod';
import { paymentInfo } from '@pages/checkout/types';
import { MappedPaymentComponentsType } from '@global/types/types';

interface IProps {
  paymentMethod: string;
  setPaymentMethod: React.Dispatch<React.SetStateAction<string>>;
  paymentMethodsCount: number;
  paymentInitData: paymentInfo;
  paymentComponentMap: MappedPaymentComponentsType;
}

const PaymentOptions: React.FC<IProps> = ({
  paymentMethod,
  paymentMethodsCount,
  paymentInitData,
  paymentComponentMap,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="payment-methods-desktop">
        <div className="order-summary__promotion select-wrapper">
          {paymentMethodsCount > 1 && (
            <h4 className="order-summary__promotion__title payment-heading">
              {t('checkout.step2.paymentMethod')}
            </h4>
          )}
          <PaymentMethod
            paymentMethod={paymentMethod}
            selectedPaymentMethod={paymentMethod}
            paymentInitData={paymentInitData}
            paymentComponentMap={paymentComponentMap}
          />
        </div>
      </div>
    </>
  );
};

export default PaymentOptions;
